import { render, staticRenderFns } from "./PilihPaket.vue?vue&type=template&id=59dbe873"
import script from "./PilihPaket.vue?vue&type=script&lang=js"
export * from "./PilihPaket.vue?vue&type=script&lang=js"
import style0 from "./PilihPaket.vue?vue&type=style&index=0&id=59dbe873&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports